// installed dependencies
import React, { Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStores } from './hooks'
// component dependencies


const SecuredRoute = ({ component: Component, path, ...rest }) => {
    const { DashboardStore } = useStores();
    const { connected } = DashboardStore;
    // console.log('securedRoute/connected:' + connected);
    // console.log(Component);
    const isConnected = connected ? connected : true; //FG- need to fix this...there is a bug
    return (
        <Route
            {...rest}
            render={(props) => {
                if (isConnected) {
                    return (
                        <Fragment>
                            {/* <SideNav /> */}
                            <Component {...props} />
                        </Fragment>
                    );
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: {
                                    from: props.location,
                                },
                            }}
                        />
                    );
                }

            }}
        />
    );
};

export default observer(SecuredRoute);